export default class CookieDate {
    getExpiryDate() {
        const date = new Date();
        const daysInMs = 182 * 24 * 60 * 60 * 1000;
        date.setTime(date.getTime() + daysInMs);
        return date.toDateString();
    }

    constructor() {}
}
